// libraries
import CountUp from 'react-countup'
import { Link } from "react-router-dom"
import parse from 'html-react-parser'
import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"

// components & functions
import Announcements from "../elektron xidmetler/GMS/Announcements"
import { apiClient } from '../../core/api_client'
import l from "../../core/localize"
import FolderCards, { FolderCardItem } from "./components/FolderCards"
import NewsHome from "./components/NewsHome"
import PeopleLinks from "./components/PeopleLinks"
import ProjectsSlider from "./components/ProjectsSlider"
import Slider from "./components/Slider"
import UsefulLinks from "./components/UsefulLinks"

// assets
import arrow_right from "../../../assets/img/utils/arrow_right.svg"
import c1 from "../../../assets/img/c1.svg"
import c2 from "../../../assets/img/c2.svg"
import c3 from "../../../assets/img/c3.svg"
// Assets below belong to the old mainpage-links block, kept commented out in the
// markup underneath. Restore these imports together with that block.
// import h1 from "../../../assets/img/h1.png"
// import h2 from "../../../assets/img/h2.svg"
// import gm_az from "../../../assets/img/gm.svg"
// import gm_en from "../../../assets/img/gm_en.svg"
// import gm_ru from "../../../assets/img/gm_ru.svg"
// import h3 from "../../../assets/img/h3.svg"
// import kommunal from "../../../assets/img/logo/logo-kommunal.svg"
// import h5 from "../../../assets/img/h5.png"
// import buildings from "../../../assets/img/buildings.svg"
// import updated_label_az from '../../../assets/img/updated_label_az.svg'
// import isnew_big_orange from '../../../assets/img/is_new_big_orange.svg'
// import isnew_big_green from '../../../assets/img/is_new_big_green.svg'
// import isnew_big from '../../../assets/img/is_new_big.svg'
// import isnew_en from '../../../assets/img/is_new_big_en.svg'
// import isnew_ru from '../../../assets/img/is_new_big_ru.svg'
// import { ProjectsModal } from '../../components/projects_modal'

interface MainPageStats {
	projects_count: number
	built_apartments_count: number
	sold_apartments_count: number
}

// Used until /mainPageStats answers, and for any field it leaves out.
const defaultStats: MainPageStats = {
	projects_count: 20,
	built_apartments_count: 16515,
	sold_apartments_count: 11925,
}

const Home = () => {
	const [activeCategory, setActiveCategory] = useState<any>(undefined)
	const [categories, setCategories] = useState([])
	const [stats, setStats] = useState<MainPageStats>(defaultStats)
	const { t, i18n } = useTranslation()
	const currentLang = i18n.language.slice(0, 2)

	const [isLoading, setLoading] = useState(true);

	useEffect(() => {
		apiClient.get('/projectCategories').then(res => {
			setCategories(res.data)
			if (res.data?.length > 0) {
				setActiveCategory(res.data[0])
				setLoading(false)
			}
		})
	}, [])

	useEffect(() => {
		apiClient.get<Partial<MainPageStats>>('/mainPageStats').then(res => {
			setStats(prev => ({
				projects_count: res.data?.projects_count ?? prev.projects_count,
				built_apartments_count: res.data?.built_apartments_count ?? prev.built_apartments_count,
				sold_apartments_count: res.data?.sold_apartments_count ?? prev.sold_apartments_count,
			}))
		}).catch(() => { })
	}, [])

	useEffect(() => {
		const bodyElement = document.body as HTMLBodyElement | null;
		if (bodyElement) {
			if (isLoading) {
				bodyElement.style.overflow = 'hidden';
			} else {
				bodyElement.style.overflow = 'visible';
			}
		}
	}, [isLoading]);

	return (
		<>
			<div>
				{isLoading && <div className='d-flex justify-content-center loading-overflow' style={{ height: window.innerHeight }}><div className="lds-roller" style={{ top: 200 }}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>}
				{<div>
					<Slider />
					<div className="home-elektron">
						<div className="pt-md-4 pb-md-0 pt-5 pb-5">
							<div className="container-lg px-md-2">
								<div className="mainpage-links block-content row mx-md-0">
									{/*
									<div className='col mainpage-link align-items-start'>
										<Link to="/elektron-xidmetler/gms/gms-kategoriyalar" className="cursor-pointer" style={{ width: "min-content" }}>
											<div className="home-main-btn hover-img position-relative p-1 p-md-3">
												<img className='mainpage-link-img' src={h1} alt='Güzəştli mənzili kim ala bilər?' style={{ aspectRatio: "1 / 1" }} />
												// <img className='position-absolute status-label-flag' src={updated_label_az} alt="{t('common:updated')}" />
											</div>
											<p className="t-color5 text-center mt-2 text-uppercase">{t('common:gms_ala_biler')}</p>
										</Link>
									</div>
									<div className='col mainpage-link align-items-start'>
										<Link to="/elektron-xidmetler/satis-elanlari" className="cursor-pointer" style={{ width: "min-content" }}>
											<div className="home-main-btn hover-img position-relative p-1 p-md-3">
												<img className='mainpage-link-img' src={h2} alt='' style={{ aspectRatio: "1 / 1" }} />
												// <img className='position-absolute new-label-flag' src={currentLang === "en" ? isnew_en : currentLang === "ru" ? isnew_ru : isnew_big} alt="Yeni" style={{ width: "55%", top: "-5%", right: "-17%" }} />
												// <img className='position-absolute status-label-flag' src={updated_label_az} alt="{t('common:updated')}" />
											</div>
											<p className="t-color5 text-center mt-2 text-uppercase">{t('common:announcements')}</p>
										</Link>
									</div>
									<div className='col mainpage-link align-items-start'>
										<Link target='_blank' rel='noreferrer' to="/satisha-chixarilacag-menziller" className="cursor-pointer" style={{ width: "min-content" }}>
											<div className="home-main-btn hover-img position-relative p-1 p-md-3">
												<img className='mainpage-link-img p-4' src={h3} alt='' style={{ aspectRatio: "1 / 1" }} />
												// <img className='position-absolute new-label-flag' src={currentLang === "en" ? isnew_en : currentLang === "ru" ? isnew_ru : isnew_big} alt="Yeni" style={{ width: "55%", top: "-5%", right: "-17%" }} />
												<img className='position-absolute status-label-flag' src={updated_label_az} alt="{t('common:updated')}" />
											</div>
											// <p className="t-color5 text-center mt-2 text-uppercase">{t('common:announcements')}</p>
											<p className="t-color5 text-center mt-2 text-uppercase">Satışa çıxarılacaq mənzillər</p>
										</Link>
									</div>
									<div className='col d-flex justify-content-center'>
										<Link to="/elektron-xidmetler/gms" className="cursor">
											<div className='position-relative gm-icon'>
												{currentLang === 'ru' ?
													<img src={gm_ru} className='gms-img' alt='Система "Льготное жилье"' />
													: currentLang === 'en' ?
														<img src={gm_en} className='gms-img' alt="Affordable Housing System" />
														:
														<img src={gm_az} className='gms-img' alt="Güzəştli mənzil sistemi" />
												}
												// <img className='position-absolute new-label-flag' src={currentLang === "en" ? isnew_en : currentLang === "ru" ? isnew_ru : isnew_big} alt="Yeni" style={{ width: "55%", top: "-1%", right: "-12%" }} />
											</div>
										</Link>
									</div>
									<div className='col mainpage-link align-items-end'>
										<a href="https://kommunal.mida.gov.az/" rel='noreferrer' target='_blank' className="cursor-pointer" style={{ width: "min-content" }}>
											<div className="home-main-btn hover-img p-1 p-md-3" style={{ backgroundColor: 'transparent', border: '2px solid #628A3F' }}>
												<img className='mainpage-link-img' src={kommunal} alt="Kommunal" style={{ aspectRatio: "1 / 1" }} />
											</div>
											<p className="text-center mt-2 text-uppercase" style={{ color: '#628A3F' }}>{t('common:kommunal')}</p>
										</a>
									</div>
									<div className='col mainpage-link align-items-end'>
										<Link to="/agentlik/hesabatlar" className="cursor-pointer" style={{ width: "min-content" }}>
											<div className="home-main-btn hover-img position-relative p-1 p-md-3">
												<img className='mainpage-link-img' src={h5} alt='Statistika' style={{ aspectRatio: "1 / 1" }} />
												// <img className='position-absolute status-label-flag' src={updated_label_az} alt="{t('common:updated')}" />
											</div>
											<p className="t-color5 text-center mt-2 text-uppercase">{t('common:stats')}</p>
										</Link>
									</div>
									*/}
									<FolderCards items={[
										{
											title: t('common:gms_ala_biler'),
											button: "QAYDALAR",
											icon: "keys",
											theme: "light",
											// badge: true,
											to: "/elektron-xidmetler/gms/gms-kategoriyalar",
										},
										{
											title: t('common:announcements'),
											button: "SATIŞ ELANLARI",
											icon: "megaphone",
											theme: "light",
											// badge: true,
											// badgeText: "Yenilənib",
											to: "/elektron-xidmetler/satis-elanlari",
										},
										{
											title: "04.09.2026-cı il tarixində satışa çıxarılan mənzillər",
											button: "MƏNZİLLƏR",
											titleFontSize: "12px",
											icon: "building",
											theme: "blue",
											// badge: true,
											// badgeText: "Yeni",
											to: "/satisha-chixarilacag-menziller",
										},
										{
											title: "Güzəştli mənzil sistemi",
											button: "GÜZƏŞTLİ MƏNZİL SİSTEMİ",
											icon: "mida",
											theme: "light",
											smallLabel: true,
											smallIcon: true,
											to: "/elektron-xidmetler/gms",
										},
										{
											title: t('common:kommunal'),
											button: "KOMMUNAL ÖDƏNİŞ SİSTEMİ",
											icon: "plant",
											theme: "green",
											smallLabel: true,
											href: "https://kommunal.mida.gov.az/",
											newTab: true,
										},
										{
											title: t('common:stats'),
											button: "STATİSTİKA",
											icon: "chart",
											theme: "light",
											to: "/agentlik/hesabatlar",
										},
									] as FolderCardItem[]} />
								</div>
							</div>
						</div>
					</div>

					<div className="home-projects block-bg-white pt-3 pb-0">
						<div className="container px-2">
							<div className="block-content">
								<h1 className="text text-center section-heading mb-md-4">{t('projects:projects')}</h1>
								<div className="breadcrumb page-link mt-sm-0 mt-lg-5 mt-md-2 mt-4 mb-2">
									<div className="container p-0 ">
										<div className="line"></div>
										<div className="bc-items d-flex col-12 justify-content-between">
											{categories.map((category: any) =>
												<p key={category.id}
													onClick={_ => setActiveCategory(category)}
													className={
														"col-12 col-md-3 bc-button fw-normal m-0 " +
														(activeCategory?.id === category.id && "bc-button-active")
													}
												>
													{l(category, "name", currentLang)}
												</p>
											)}
										</div>
									</div>
								</div>
								<div className="mt-2 mt-sm-5">
									{activeCategory &&
										<ProjectsSlider categoryId={activeCategory.id} />
									}
								</div>
							</div>
						</div>
					</div>

					<div className="home-stats pt-2 block-bg-white cursor">
						<div className="container-lg m-md-auto px-md-2">
							{/* <ProjectsModal className="block-content row justify-content-md-center justify-content-between px-3 px-md-0"> */}
							<div className="block-content row justify-content-md-center justify-content-between px-3 px-md-0">
								<div className="home-stats-item col-sm-3 col-3 d-flex my-sm-0 my-3 mx-md-4 justify-content-center align-items-center p-0">
									<img src={c1} style={{ width: "100px", height: "100px" }} className='me-2' alt='' />
									<div className="ms-md-2 me-md-2">
										<small className="t-color1">
											{parse(t('common:all_proj_count'))}
										</small>
										<h2
											className="t-color5"
											style={{ fontSize: "28px", fontWeight: 700 }}
										>
											<CountUp start={1} end={stats.projects_count} duration={4} redraw={true} separator=" " />
										</h2>
									</div>
								</div>
								<div className="home-stats-item col-sm-3 col-3 d-flex flex-nowrap my-sm-0 my-3 mx-md-4 justify-content-center align-items-center p-0">
									<img src={c2} style={{ width: "100px", height: "100px" }} className='me-2' alt='' />
									<div className="ms-md-2 me-md-2">
										<small className="t-color1">
											{parse(t('common:done_apts_count'))}
										</small>
										<h2
											className="t-color5"
											style={{ fontSize: "28px", fontWeight: 700 }}
										>
											<CountUp start={1} end={stats.built_apartments_count} duration={3} redraw={true} separator=" " />
										</h2>
									</div>
								</div>
								<div className="home-stats-item col-sm-3 col-4 d-flex flex-nowrap my-sm-0 my-3 mx-md-4 justify-content-center align-items-center p-0">
									<img src={c3} style={{ width: "100px", height: "100px" }} className='me-2' alt='' />
									<div className="ms-md-2 me-md-2">
										<small className="t-color1">
											{parse(t('common:apts_taken_count'))}
										</small>
										<h2
											className="t-color5"
											style={{ fontSize: "28px", fontWeight: 700, whiteSpace: "nowrap" }}
										>
											<CountUp start={1} end={stats.sold_apartments_count} duration={3} redraw={true} separator=" " />
										</h2>
									</div>
								</div>
							</div>
							{/* </ProjectsModal> */}
							<Link
								to="/layiheler"
								className="btn-container d-flex justify-content-end mt-2 mb-4">
								<span className="more-info-btn">
									<small>{t('projects:all_projects')}</small>
									<img className="ms-2" src={arrow_right} alt="" />
								</span>
							</Link>
						</div>
					</div>

					<div className="home-announcements block-bg1 pt-4 pb-3">
						<div className="container px-2">
							<div className="block-content">
								<h1 className="text text-center section-heading">{t('common:announcements')}</h1>
								<div className="m-2 mt-3 mb-2 row justify-content-between">
									<Announcements />
								</div>
								<div className="btn-container d-flex justify-content-end my-md-3 mt-3">
									<Link to="/elektron-xidmetler/satis-elanlari" className="more-info-btn">
										<small>{t('common:all_announcements')}</small>
										<img className="ms-2" src={arrow_right} alt="" />
									</Link>
								</div>
							</div>
						</div>
					</div>
					<div className="home-news block-bg1 block-bg-white py-3">
						<div className="container px-2">
							<h1 className="text text-center section-heading mt-md-3">{t('common:news')}</h1>
							<NewsHome />
						</div>
					</div>
					<div className="home-biglinks block-bg1 pt-md-60 pb-md-80 py-4">
						<div className="container px-lg-2">
							<PeopleLinks />
							<div className="mt-md-5 flex-wrap">
								<UsefulLinks />
							</div>
						</div>
					</div>
				</div>
				}
			</div>
		</>
	)
}

export default Home 
